import {Plural, Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {AsyncStatusesEnum} from '../../../libs/shared/helpers/src/types/asyncStatuses';
import {OkCancelDialog} from '../../components/common/dialogs/okCancelDialog';
import {cutoffTimes} from '../../components/inboxes/dialogs/massArchiveCutoffDropdown';
import {MassArchiveCutoffDropdownBox} from '../../components/inboxes/dialogs/massArchiveCutoffDropdownBox';
import {useAppDispatch} from '../../helpers/reduxHelpers';
import {ApiEmailCount} from '../../models/api/emailCountModel';
import {InboxModel} from '../../models/api/inboxModel';
import {fetchApiAsync} from '../../services/http/http';
import {createMassArchiveJobAsyncAction} from '../../store/data/jobs/jobsActions';
import {useSettingsQuery} from '../helpers/useSettingsQuery';

/*
 * Props.
 */

interface SettingsInboxMassArchiveDialogProps {
  inbox: InboxModel;
  onRequestClose: Handler;
}

/*
 * Style.
 */

const StyledDropdownBoxDiv = styled.div``;

/*
 * Component.
 */

export const SettingsInboxMassArchiveDialog: FC<SettingsInboxMassArchiveDialogProps> = (props) => {
  const [selectedCutoff, setSelectedCutoff] = useState(cutoffTimes[0]);
  const {data, asyncStatus} = useSettingsQuery(
    ['conversationCount', {id: props.inbox.id, cutoff: selectedCutoff.trackLabel}],
    async ({cancelToken}) =>
      fetchApiAsync(
        ApiEmailCount,
        `${props.inbox.url}/count_conversations?status=open&before_date=${selectedCutoff.beforeDate()}`,
        {cancelToken},
      ),
    {initialData: {count: 0}},
  );
  const dispatch = useAppDispatch();
  const onOkClick = async () => {
    dispatch(createMassArchiveJobAsyncAction(props.inbox.url, selectedCutoff.beforeDate()));
    props.onRequestClose();
  };

  return (
    <OkCancelDialog
      title={<Trans id="settingsinboxes-massarchive-title">Archive conversations</Trans>}
      onOkClick={onOkClick}
      onRequestClose={() => props.onRequestClose()}
      isOkDisabled={asyncStatus !== AsyncStatusesEnum.LOADED}
    >
      <Trans id="settingsinboxes-massarchive-copy">Archive all conversations received before:</Trans>
      <StyledDropdownBoxDiv>
        <MassArchiveCutoffDropdownBox
          showCustom
          selectedCutoff={selectedCutoff}
          onCutoffSelect={setSelectedCutoff}
        />
      </StyledDropdownBoxDiv>
      <Plural
        id="settingsinboxes-massarchive-conversationscount"
        value={data?.count || 0}
        zero="No conversations will be archived"
        one="One conversation will be archived"
        other="# conversations will be archived"
      />
    </OkCancelDialog>
  );
};
